// extracted by mini-css-extract-plugin
module.exports = {"ShareLink":"social_media_share_icon-module--ShareLink--21lDI"};